export const GET_ONBOARDING_REQUESTS_REQUEST = "GET_ONBOARDING_REQUESTS_REQUEST"
export const GET_ONBOARDING_REQUESTS_SUCCESS = "GET_ONBOARDING_REQUESTS_SUCCESS"
export const GET_ONBOARDING_REQUESTS_FAILURE = "GET_ONBOARDING_REQUESTS_FAILURE"
export const GET_NEXT_PAGE_ONBOARDING_REQUESTS_REQUEST = "GET_NEXT_PAGE_ONBOARDING_REQUESTS_REQUEST"